"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgSchemaViewerBlank = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", id: "schema-viewer-blank_svg__Blank", width: 24, height: 17, x: 0, y: 0 }, props)));
const Memo = (0, react_1.memo)(SvgSchemaViewerBlank);
exports.default = Memo;
//# sourceMappingURL=SchemaViewerBlank.js.map